import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { GetGisStandPerRegistersInputDto, GisStandPerRegisterCreateDto, GisStandPerRegisterDto, GisStandPerRegisterExcelDownloadDto, GisStandPerRegisterUpdateDto } from '../dtos/gis-stand-per-register/models';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';

@Injectable({
  providedIn: 'root',
})
export class GisStandPerRegisterService {
  private restService = inject(RestService);
  apiName = 'Geographic';
  

  create = (input: GisStandPerRegisterCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, GisStandPerRegisterDto>({
      method: 'POST',
      url: '/api/geographic/gisStandPerRegisters',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/geographic/gisStandPerRegisters/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/geographic/gisStandPerRegisters',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, GisStandPerRegisterDto>({
      method: 'GET',
      url: `/api/geographic/gisStandPerRegisters/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/geographic/gisStandPerRegisters/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetGisStandPerRegistersInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<GisStandPerRegisterDto>>({
      method: 'GET',
      url: '/api/geographic/gisStandPerRegisters',
      params: { standLocationId: input.standLocationId, registerLocationId: input.registerLocationId, standRegisterArea: input.standRegisterArea, standRegisterAreaFrom: input.standRegisterAreaFrom, standRegisterAreaTo: input.standRegisterAreaTo, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: GisStandPerRegisterExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/geographic/gisStandPerRegisters/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, standLocationId: input.standLocationId, registerLocationId: input.registerLocationId, standRegisterArea: input.standRegisterArea, standRegisterAreaFrom: input.standRegisterAreaFrom, standRegisterAreaTo: input.standRegisterAreaTo, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, GisStandPerRegisterDto[]>({
      method: 'GET',
      url: '/api/geographic/gisStandPerRegisters/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: GisStandPerRegisterUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, GisStandPerRegisterDto>({
      method: 'PUT',
      url: `/api/geographic/gisStandPerRegisters/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}